export default __webpack_public_path__ + "static/media/1769.800cc93a.png";